import React, { useEffect, useState, useCallback } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublishmentsData } from "../../features/publishments/publishment";
import PublishmentCard from "./PublishmentCard";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Pagination from "../../Pagination/Pagination";
import Loading from "../Loading";

// Animation variants
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      when: "beforeChildren"
    }
  }
};

function AllPublishment() {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const [perPage, setPerPage] = useState(12);
  const { publishments,loading,total } = useSelector((state) => state.publishments);
  const [currentPage, setCurrentPage] = useState(1);
  const HandleLoadMore = () => {
    setPerPage(prev => prev + 6);
  }
  useEffect(() => {
    dispatch(fetchPublishmentsData({perPage,page:currentPage}));
  }, [dispatch, perPage, i18n.language,currentPage]);
  const handleNext = () => setCurrentPage((prev) => prev + 1);
  const handlePrev = () => setCurrentPage((prev) => prev - 1);
  if(loading) return <Loading/>
  return (
    <motion.div
      className="w-11/12 lg:w-10/12 mx-auto py-10"
      initial="hidden"
      animate="visible"
    >

      <motion.div className="flex flex-col gap-4">
        <motion.p
          className="font-bold text-center capitalize my-3 text-4xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {t("ourPublications")}
        </motion.p>
      </motion.div>

      {publishments?.length === 0 ? (
        <motion.div
          className="flex flex-col gap-4 items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <p className="font-bold text-center capitalize my-3 text-4xl">
            There is no news yet
          </p>
        </motion.div>
      ) : (
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={containerVariants}
        >
          {publishments.map((publishment, index) => (
            <motion.div
              key={publishment.id}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <Link to={`/publication/${publishment.id}`}>
                <PublishmentCard publishment={publishment} />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      )}
      
      {total !=0 && (
        <Pagination
          prevPage={handlePrev}
          nextPage={handleNext}
          showPage={Math.ceil(total / perPage)}
          total={total}
          page={currentPage}
          setPage={setCurrentPage}
          HandleLoadMore={HandleLoadMore}
        />
      )}
    </motion.div>
  );
}

export default AllPublishment;